/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteTimecardBreakDefinitionRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {DeleteTimecardBreakDefinitionResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const deleteTimecardBreakDefinition = (request: DeleteTimecardBreakDefinitionRequest, options?: CashRequestOptions) => post<DeleteTimecardBreakDefinitionRequest, DeleteTimecardBreakDefinitionResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/DeleteTimecardBreakDefinition", request, {...options, rejectOnError: true })